import { Link } from "react-router-dom";
import { useState } from "react";
import contactImg from "../assets/images/illastration-6.png";

function Contact() {

  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);

  // Input change handle
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Form submit
  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.message) {
      alert("Please fill all required fields");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("http://datroniq.com/api/send-mail.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form)
      });

      const data = await res.json();

      alert(data.message);

      // Reset form
      setForm({
        name: "",
        email: "",
        subject: "",
        message: ""
      });

    } catch (error) {
      alert("Something went wrong ❌");
    }

    setLoading(false);
  };

  return (
    <>
      {/* Breadcrumb */}
      <section className="page-title custom-breadcrumb">
        <div className="overlay"></div>
        <div className="auto-container">
          <div className="content-box">
            <h1>Contact Us</h1>

            <ul className="bread-crumb">
              <li><Link to="/">Home</Link></li>
              <li><span>→</span></li>
              <li className="active">Contact Us</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-modern">

        <div className="contact-header">
          <span>Contact Information</span>
          <h2>We’d love to hear from you anytime</h2>
        </div>

        <div className="contact-info-modern">

          <div className="info-box">
            <div className="icon">📍</div>
            <div className="content">
              <h4>Location</h4>
              <p>Mahaveer Nagar, Kota(Raj.)</p>
            </div>
          </div>

          <div className="info-box">
            <div className="icon">🎧</div>
            <div className="content">
              <h4>Make a Call</h4>
              <p>9929075545</p>
            </div>
          </div>

          <div className="info-box">
            <div className="icon">✉️</div>
            <div className="content">
              <h4>Send a Mail</h4>
              <p>info@datroniq.io</p>
            </div>
          </div>
        </div>

        <div className="contact-body-modern">

          {/* FORM */}
          <div className="contact-form-box">
            <h3>Send Message</h3>

            <div className="form-group">
              <label>Your Name</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Enter name here"
              />
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Email Address"
              />
            </div>

            <div className="form-group">
              <label>Subject</label>
              <input
                type="text"
                name="subject"
                value={form.subject}
                onChange={handleChange}
                placeholder="Subject"
              />
            </div>

            <div className="form-group">
              <label>Message</label>
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Message goes here"
              ></textarea>
            </div>

            <button className="btn-submit" onClick={handleSubmit}>
              {loading ? "Sending..." : "Send Your Message"}
            </button>
          </div>

          {/* IMAGE */}
          <div className="contact-image-box">
            <img src={contactImg} alt="illustration" />
          </div>

        </div>

      </section>
    </>
  );
}

export default Contact;